<template>
  <chat-message :prev-chat="prevChat" :chat="chat" @delete="$emit('delete', chat)">
    <ul class="chat-message__actions" :class="{'disabled-action': !active}">
      <li
        v-for="(action, index) in chat.message_rich.actions"
        :key="index"
        v-theme-bg-hover
        :class="checkActionState(index)"
        @click="clickAction(action)"
      >
        {{ action.text }}
      </li>
    </ul>

    <custom-bot-payment-modal
      :visible.sync="paymentModalVisible"
      fullscreen
      transition="slide-right"
      :message="chat"
      @payment-success="handlePaymentSuccess"
    ></custom-bot-payment-modal>
  </chat-message>
</template>

<script>
import ActionWidget from './ActionWidget.vue'
import CustomBotPaymentModal from 'ChatWindow/Payment/CustomBotPaymentModal'
import { useCreditCardPaymentMethodStore } from 'Store/credit-card-payment-method'

export default {
  components: { CustomBotPaymentModal },

  extends: ActionWidget,

  setup() {
    const creditCardPaymentMethodStore = useCreditCardPaymentMethodStore()

    return { creditCardPaymentMethodStore }
  },

  props: {
    choosePaymentMethod: { type: Function, requierd: true },
    newPaymentMethod: { type: Function, required: true }
  },

  data() {
    return {
      paymentModalVisible: false,
      active: this.chat.message_rich.hasOwnProperty('active')
        ? this.chat.message_rich.active
        : true,
      actions: this.chat.message_rich.actions
    }
  },

  methods: {
    handlePaymentSuccess() {
      this.active = false
    },
    clickAction(action) {
      if (this.active) {
        // We will send the chat message ID and action back to the backend
        // The message ID is to disable the action widget in the future
        // The action is for serverflow and will contain the card token

        if (action.action === 'payment') {
          this.paymentModalVisible = true
        } else if (action.action) {
          this.active = false
          action.selected = true
          this.choosePaymentMethod({ sequence: action.action }, action.text, this.chat.id)
        } else {
          // New card
          // Pass the chat message ID to disable the widget in backend
          this.newPaymentMethod(this.chat.id)
          if (this.chat.message_rich.options.showSaveCard !== undefined) {
            this.creditCardPaymentMethodStore.updateShowSaveCard(
              this.chat.message_rich.options.showSaveCard
            )
          }
          if (this.chat.message_rich.options.defaultSaveCard !== undefined) {
            this.creditCardPaymentMethodStore.updateSaveCard(
              this.chat.message_rich.options.defaultSaveCard
            )
          }
          this.creditCardPaymentMethodStore.updateReservationMonth(
            this.chat.message_rich.options.reservationMonth
          )
          this.creditCardPaymentMethodStore.updateReservationId(
            this.chat.message_rich.options.reservationId
          )
        }
      }
    }
  }
}
</script>
